import { api } from "@/api";
import { AptiError } from "@/core/errors";
import type { GetPresignedUrlForGetPayload, GetPresignedUrlForGetResponse } from "@/core/types";

export async function getPresignedUrl(
  payload: Omit<GetPresignedUrlForGetPayload, "method" | "content_type">,
): Promise<GetPresignedUrlForGetResponse> {
  try {
    const response = await api.sharedTyped.get_presigned_url({
      data: { method: "get_object", content_type: "json", ...payload },
    });

    // Handle null/undefined response from API
    if (!response) {
      throw new AptiError({
        code: "S3_INVALID_PRESIGNED_RESPONSE",
        message: "Backend returned empty response - this may indicate a server error",
      });
    }

    return response;
  } catch (error) {
    // Re-throw AptiError validation errors as-is
    if (error instanceof AptiError) {
      throw error;
    }

    // Wrap other errors with context
    throw new AptiError({
      cause: error,
      code: "S3_PRESIGNED_URL_FAILED",
      message: "Failed to get presigned URL for S3 download",
    });
  }
}
